import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  heading: string;
  intro?: string;
  tone?: 'dark' | 'light';
  id?: string;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  heading,
  intro,
  tone = 'dark',
  id,
  className = ''
}: SectionHeadingProps) {
  const headingColor = tone === 'dark' ? 'text-navy' : 'text-white';
  const introColor = tone === 'dark' ? 'text-graphite/80' : 'text-aluminum';
  return <div className={className} data-id="element-353" data-mp="bkvjswyxswz5">
      <p className="flex items-center gap-3 font-mono text-[10px] tracking-label text-copper" data-id="element-354" data-mp="gjgl6zpxdmp6">
        <span aria-hidden="true" className="h-px w-8 bg-copper" data-id="element-355" data-mp="glaypsyvacj8" />
        {eyebrow}
      </p>
      <h2 id={id} className={`mt-5 max-w-[22ch] font-display text-[clamp(1.75rem,3.2vw,2.9rem)] font-medium leading-[1.1] tracking-[-0.01em] ${headingColor}`} data-id="element-356" data-mp="1spszqkf8llj">
        {heading}
      </h2>
      {intro ? <p className={`rp-measure mt-6 text-[15.5px] leading-[1.65] ${introColor}`} data-id="element-357" data-mp="zahjrmn4vg87">
          {intro}
        </p> : null}
    </div>;
}